export default __webpack_public_path__ + "static/media/let-it-snow-sinatra.2946f3fb.mp3";